import { C_MEMBER_ACCESS_RULES } from './c.js';
import { CPP_MEMBER_ACCESS_RULES } from './cpp.js';
import { GO_MEMBER_ACCESS_RULES } from './go.js';
import { JAVASCRIPT_MEMBER_ACCESS_RULES } from './javascript.js';
import { JAVA_MEMBER_ACCESS_RULES } from './java.js';
import { PYTHON_MEMBER_ACCESS_RULES } from './python.js';
import { RUBY_MEMBER_ACCESS_RULES } from './ruby.js';
import { RUST_MEMBER_ACCESS_RULES } from './rust.js';
import { TSX_MEMBER_ACCESS_RULES } from './tsx.js';
import { TYPESCRIPT_MEMBER_ACCESS_RULES } from './typescript.js';
import type { MemberAccessRule } from './types.js';

export const MEMBER_ACCESS_RULES_BY_LANGUAGE_KEY: Readonly<Record<string, readonly MemberAccessRule[]>> = {
  javascript: JAVASCRIPT_MEMBER_ACCESS_RULES,
  typescript: TYPESCRIPT_MEMBER_ACCESS_RULES,
  tsx: TSX_MEMBER_ACCESS_RULES,
  python: PYTHON_MEMBER_ACCESS_RULES,
  go: GO_MEMBER_ACCESS_RULES,
  rust: RUST_MEMBER_ACCESS_RULES,
  ruby: RUBY_MEMBER_ACCESS_RULES,
  java: JAVA_MEMBER_ACCESS_RULES,
  c: C_MEMBER_ACCESS_RULES,
  cpp: CPP_MEMBER_ACCESS_RULES,
};

export function memberAccessRulesForLanguageKey(languageKey: string | null): readonly MemberAccessRule[] {
  if (!languageKey) return [];
  return MEMBER_ACCESS_RULES_BY_LANGUAGE_KEY[languageKey] ?? [];
}
